import './gallery.css'
import { useI18n } from '../lib/i18n'
import { Reveal } from '../components/Reveal'
import { SectionHeader } from '../components/SectionHeader'
import { ThumbnailsCarousel } from '../components/ThumbnailsCarousel'

// 03 · VÙNG TRỒNG — real coffee photography (Pexels), treated as "field imagery
// from the network": darkened, bracket-framed, mono captions, so the photos sit
// inside the dark instrument. The chain ends on ARGO's own render of a parcel
// (the landing's 3D story, parcel 35030): "from farm to dossier" taken literally.
// `focus` picks the crop for the 16:9 stage (several photos are 3:2 or portrait).
const PHOTOS = [
  { src: 'field-landscape', focus: '45% 64%', vi: 'Cao nguyên Lâm Đồng', en: 'Lâm Đồng highlands' },
  { src: 'cherries', focus: '50% 42%', vi: 'Quả chín đỏ', en: 'Ripe cherries' },
  { src: 'harvest', focus: '40% 62%', vi: 'Thu hái', en: 'Harvest' },
  { src: 'farmer-bmt', focus: '50% 48%', vi: 'Nông hộ Buôn Ma Thuột', en: 'Buôn Ma Thuột farmer' },
  { src: 'drying', vi: 'Cà phê nhân', en: 'Green coffee' },
  { src: 'highlands', focus: '58% 60%', vi: 'Đồi cà phê Tây Nguyên', en: 'Central Highlands' },
  { src: 'aerial', vi: 'Ranh thửa từ trên cao', en: 'Plot boundaries · aerial' },
  { src: 'argo-parcel', raw: true, vi: 'Thửa cà phê dựng lại trên ARGO', en: 'A parcel rebuilt in ARGO' },
]

export default function Gallery() {
  const { lang } = useI18n()
  const C = ({
    vi: {
      kicker: 'VÙNG TRỒNG',
      title: <>Cà phê Việt Nam, <em>từ vườn tới hồ sơ</em>.</>,
      sub: 'Mỗi khung hình là một mắt xích trong chuỗi truy xuất — từ cao nguyên Tây Nguyên tới bao hàng xuất khẩu.',
      credit: 'Ảnh: Pexels (giấy phép miễn phí). Ảnh cuối do ARGO dựng từ dữ liệu Sentinel-2 và Meta/WRI.',
    },
    en: {
      kicker: 'GROWING REGIONS',
      title: <>Vietnamese coffee, <em>from farm to dossier</em>.</>,
      sub: 'Each frame is a link in the traceability chain — from the Central Highlands to the export bag.',
      credit: 'Photos: Pexels (free license). Last frame rendered by ARGO from Sentinel-2 and Meta/WRI data.',
    },
  } as const)[lang]

  return (
    <section id="regions" className="section gallery">
      <div className="container">
        <SectionHeader index="03" kicker={C.kicker} title={C.title} sub={C.sub} />
        <Reveal delay={0.06} y={28}>
          <ThumbnailsCarousel
            items={PHOTOS.map((p, i) => ({
              src: `/img/${p.src}.jpg`,
              caption: lang === 'vi' ? p.vi : p.en,
              index: String(i + 1).padStart(2, '0'),
              focus: p.focus,
              raw: p.raw,
            }))}
          />
        </Reveal>
        <p className="gallery-credit label">{C.credit}</p>
      </div>
    </section>
  )
}
